var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4205_3569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0.75C7.39239 0.75 8.72774 1.30312 9.71231 2.28769C10.6969 3.27226 11.25 4.60761 11.25 6C11.25 7.39239 10.6969 8.72774 9.71231 9.71231C8.72774 10.6969 7.39239 11.25 6 11.25C4.60761 11.25 3.27226 10.6969 2.28769 9.71231C1.30312 8.72774 0.75 7.39239 0.75 6C0.75 4.60761 1.30312 3.27226 2.28769 2.28769C3.27226 1.30312 4.60761 0.75 6 0.75ZM5.346 7.03575L4.17975 5.86875C4.13794 5.82694 4.08831 5.79378 4.03368 5.77115C3.97905 5.74852 3.9205 5.73687 3.86137 5.73687C3.80225 5.73687 3.7437 5.74852 3.68907 5.77115C3.63444 5.79378 3.58481 5.82694 3.543 5.86875C3.45856 5.95319 3.41112 6.06771 3.41112 6.18713C3.41112 6.30654 3.45856 6.42106 3.543 6.5055L5.028 7.9905C5.06969 8.03252 5.11929 8.06587 5.17393 8.08864C5.22857 8.1114 5.28718 8.12312 5.34637 8.12312C5.40557 8.12312 5.46418 8.1114 5.51882 8.08864C5.57346 8.06587 5.62306 8.03252 5.66475 7.9905L8.73975 4.91475C8.78212 4.87311 8.81582 4.8235 8.83892 4.76877C8.86202 4.71405 8.87405 4.65529 8.87433 4.59588C8.87461 4.53648 8.86312 4.47761 8.84053 4.42267C8.81794 4.36773 8.7847 4.31781 8.74272 4.27578C8.70074 4.23375 8.65086 4.20045 8.59594 4.1778C8.54103 4.15515 8.48218 4.14359 8.42277 4.14379C8.36337 4.144 8.3046 4.15597 8.24984 4.179C8.19509 4.20203 8.14544 4.23568 8.10375 4.278L5.346 7.03575Z",
    fill: "#169560"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4205_3569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0ca93eb7db151240277e335848c0c005.svg";
export { ForwardRef as ReactComponent };